/*!
 * BGC Range + Regulator Duo interactions — owned by AGENT-RANGE
 * Sections: bgc-range.liquid, bgc-regulator-duo.liquid
 * Wires "Add to cart" / "Add both" buttons to window.BGC.addToCart (bgc-core.js).
 * Reveal-on-scroll is handled globally by bgc-core.js via the rv/data-rv classes —
 * this file does not implement its own reveal system.
 */
(function () {
  "use strict";

  var hasSections = document.querySelector(".bgc-range, .bgc-regduo");
  if (!hasSections) return;

  function getBGC() {
    return window.BGC && typeof window.BGC.addToCart === "function" ? window.BGC : null;
  }

  function handleAdd(btn) {
    if (!btn || btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;
    var bgc = getBGC();
    if (!bgc) {
      console.warn("[bgc-range] window.BGC.addToCart is not available yet.");
      return;
    }
    bgc.addToCart(variantId);
  }

  /* window.BGC.addToCart never rejects (bgc-core.js swallows fetch/parse
     errors internally and shows its own toast), so success has to be
     inferred from the resolved payload shape: a real Shopify line item
     has an id/variant_id and no "status" field, while a caught error or
     a 4xx cart/add.js response resolves to undefined or a {status,...}
     error object. Only redirect when both adds look genuinely successful. */
  function isSuccessItem(item) {
    return !!item && typeof item === "object" && !item.status && (item.id || item.variant_id);
  }

  function handleAddBoth(btn) {
    if (!btn || btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
    var id1 = btn.getAttribute("data-variant-id-1");
    var id2 = btn.getAttribute("data-variant-id-2");
    var redirectTo = btn.getAttribute("data-redirect") || "/cart";
    var bgc = getBGC();
    if (!bgc) {
      console.warn("[bgc-range] window.BGC.addToCart is not available yet.");
      return;
    }

    var adds = [];
    if (id1) adds.push(bgc.addToCart(id1));
    if (id2) adds.push(bgc.addToCart(id2));
    if (!adds.length) return;

    btn.disabled = true;
    btn.setAttribute("aria-disabled", "true");

    Promise.all(adds)
      .then(function (results) {
        var allOk = results.length > 0 && results.every(isSuccessItem);
        if (allOk) {
          window.location.href = redirectTo;
          return;
        }
        // Failure path: bgc-core.js already surfaced its own error toast
        // for the failed add(s) — just re-enable the button so the
        // shopper can retry instead of silently redirecting.
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
      });
  }

  document.addEventListener("click", function (evt) {
    var addBtn = evt.target.closest("[data-bgc-add]");
    if (addBtn) {
      evt.preventDefault();
      handleAdd(addBtn);
      return;
    }

    var bothBtn = evt.target.closest("[data-bgc-add-both]");
    if (bothBtn) {
      evt.preventDefault();
      handleAddBoth(bothBtn);
    }
  });
})();
